import React from 'react';
import { motion } from 'framer-motion';
import EditableField from './EditableField';
import './Footer.css';

function Footer() {
  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <div className="footer__content">
          <div className="footer__brand">
            <span className="footer__logo">
              <span className="footer__logo-dot" />
              Ramesh Genomal
            </span>
            <EditableField
              storageKey="footer-tagline"
              defaultValue="Director, Philanthropist & Founder of Chummy Chum Foundation."
              tag="p"
              className="footer__tagline"
            />
          </div>

          <div className="footer__links">
            <a href="#about">My Story</a>
            <a href="#skills">Expertise</a>
            <a href="#projects">Initiatives</a>
            <a href="#experience">Career</a>
            <a href="#gallery">Gallery</a>
            <a href="#contact">Get In Touch</a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Ramesh Genomal. All rights reserved.</p>
          <p className="footer__credit">Designed & Built with care</p>
        </div>
      </div>
    </motion.footer>
  );
}

export default Footer;
